import styled from "styled-components";
import Img from "gatsby-image";
import BackgroundImage from "gatsby-background-image";
export const ProjectBackgroundImageContainer = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  padding: relative;
  transition: 0.2s ease;
  margin-right: 20px;
  animation-duration: 0.2s;
  color: #7d605f;
`;
export const ProjectDataWrapper = styled.div`
  display: block;
  padding: 20px;
  @media (max-width: 786px) {
    padding: 10px;
  }
  @media (max-width: 586px) {
    padding: 5px;
  }
`;
export const ProjectInfoTextWrapper = styled.div`
  padding: 10px;
  display: block;
  @media (max-width: 786px) {
    padding: 5px;
  }
  @media (max-width: 586px) {
    padding: 2px;
  }
`;
export const ProjectWrapperMainTitle = styled.p`
  /* padding: 10px; */
  text-transform: uppercase;
  color: #5e0087;
  font-weight: 500px;
  font-size: 24px;
  display: block;
`;
export const ProjectWrapperTitle = styled.p`
  /* padding: 10px; */
  text-transform: uppercase;
  color: #5e0087;
  font-weight: 500px;
  font-size: 20px;
  display: block;
`;
export const SmallText = styled.p`
  padding-top: 10px;
  padding-left: 10px;
  font-size: 12px;
  display: inline;
  text-transform: capitalize;
  font-style: italic;
`;
export const LargeText = styled.p``;
export const ProjectWrapper = styled.div`
  display: block;
  padding: 5px;
`;
export const CategoryWrapper = styled.div`
  display: block;
  padding: 5px;
  margin-top: 2rem;
`;
export const SkillTags = styled.div`
  margin-top: 4px;
  display: inline-block;
  padding: 3px;
  font-size: ${({ small }) => (small ? "10px" : "13px")};
  margin-left: ${({ small }) => (small ? "10px" : "0px")};
  border-radius: ${({ small }) => (small ? "4px" : "0px")};
  background: ${({ small }) => (small ? "#f6f4ff" : "inherited")};
  padding-left: ${({ small }) => (small ? "10px" : "3px")};
  padding-right: ${({ small }) => (small ? "10px" : "3px")};
  word-wrap: break-word;
  overflow-wrap: break-word;
  cursor: pointer;
  white-space: nowrap;
  color: #413a4e;
  width: fit-content;
  text-transform: ${({ small }) => (small ? "capitalize" : "uppercase")};
  &:hover {
    background: #eae8ee;
    color: #00578a;
    -webkit-transition: background 0.2s ease-in-out;
    transition: background 0.2s ease-in-out;
    -ms-transition: background 0.2s ease-in-out;
    -webkit-transition: color 0.2s;
    transition: color 0.2s ease-in-out;
    -ms-transition: color 0.2s ease-in-out;
    -webkit-transition: border 0.2s;
    transition: border 0.2s ease-in-out;
    -ms-transition: border 0.2s ease-in-out;
  }
`;
export const AchivementTags = styled.div`
  margin: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 5px;
  padding-right: 5px;
  background: #f6f4ff;
  font-size: 12px;
  display: inline-block;
  width: fit-content;
  color: #413a4e;
  word-wrap: break-word;
  overflow-wrap: break-word;
  cursor: pointer;
  text-transform: capitalize;
  border-radius: 3px;
  -webkit-transition: background 0.2s ease-in-out;
  transition: background 0.2s ease-in-out;
  -ms-transition: background 0.2s ease-in-out;
  -webkit-transition: color 0.2s;
  transition: color 0.2s ease-in-out;
  -ms-transition: color 0.2s ease-in-out;
  -webkit-transition: border 0.2s;
  transition: border 0.2s ease-in-out;
  -ms-transition: border 0.2s ease-in-out;
  &:hover {
    color: #00578a;
    background: #eae8ee;
    -webkit-transition: background 0.2s ease-in-out;
    transition: background 0.2s ease-in-out;
    -ms-transition: background 0.2s ease-in-out;
    -webkit-transition: color 0.2s;
    transition: color 0.2s ease-in-out;
    -ms-transition: color 0.2s ease-in-out;
    -webkit-transition: border 0.2s;
    transition: border 0.2s ease-in-out;
    -ms-transition: border 0.2s ease-in-out;
  }
`;
export const Heading = styled.div`
  padding: 10px;
  text-transform: capitalize;
  color: #1c0824;
  font-weight: 400;
  font-size: 20px;
  display: inline;
`;
export const Subheading = styled.div`
  text-transform: capitalize;
  color: #1c0824;
  font-weight: 250px;
  font-style: italic;
  font-size: 18px;
  display: inline;
`;

export const Text = styled.p`
  padding: 10px;
  text-transform: initial;
  font-size: 16px;
  max-width: 850px;
`;
export const WrapContent = styled.div`
  display: block;
  padding-right: 10px;
`;
